interface FigmaCoverageProps {
  handleClick: () => void;
}

export function FigmaCoverage({ handleClick }: FigmaCoverageProps) {
  return (
    <section className="bg-white py-[32px] md:py-[50px]">
      <div className="container mx-auto px-4 max-w-[1560px]">
        <h2 className="text-[#101828] text-[24px] md:text-[30px] font-bold leading-[30px] md:leading-[36px] text-center mb-2">
          El Seguro de Patinetes eléctricos ya es obligatorio en España
        </h2>
        <p className="text-[#4a5565] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-center mb-[32px] md:mb-[46px] px-4">
          Desde el 30 de enero de 2026 es exigible el seguro obligatorio para
          que los patinetes eléctricos estén asegurados para poder circular.
        </p>

        {/* Card */}
        <div className="max-w-[610px] mx-auto">
          <div className="bg-white border border-[#e5e7eb] rounded-[8px] p-6 md:p-8">
            <h3 className="text-[#101828] text-[18px] md:text-[20px] font-bold leading-[24px] md:leading-[28px] text-center mb-4">
              Seguro de Patinetes eléctricos
            </h3>

            <div className="text-center mb-6">
              <div>
                <span className="text-[#ff6900] text-[32px] md:text-[36px] font-bold leading-[40px]">
                  99€
                </span>
                <span className="text-[#4a5565] text-[16px] leading-[24px]">
                  /año
                </span>
              </div>
              <div className="text-[#4a5565] text-[11px] md:text-[12px] leading-[16px] mt-1">
                (impuestos y recargos incluidos)
              </div>
            </div>

            <p className="text-[#101828] text-[14px] font-semibold leading-[20px] text-center mb-4">
              Coberturas:
            </p>

            <div className="space-y-[10px] mb-8 max-w-[456px] mx-auto">
              <div className="flex items-start gap-2">
                <div className="bg-[#ff6900] rounded-full w-[20px] h-[20px] flex items-center justify-center flex-shrink-0 mt-[2px]">
                  <svg
                    className="w-[12px] h-[12px]"
                    fill="none"
                    viewBox="0 0 12 12"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <p className="text-[#364153] text-[14px] leading-[20px]">
                  Responsabilidad Civil hasta 7.750.000€ por siniestro
                  cumpliendo la ley (hasta 6.450.000€ de daños personales por
                  siniestro cualquiera que sea el número de víctimas y hasta
                  1.300.000€ de daños materiales por siniestro)
                </p>
              </div>

              <div className="flex items-start gap-2">
                <div className="bg-[#ff6900] rounded-full w-[20px] h-[20px] flex items-center justify-center flex-shrink-0 mt-[2px]">
                  <svg
                    className="w-[12px] h-[12px]"
                    fill="none"
                    viewBox="0 0 12 12"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <p className="text-[#364153] text-[14px] leading-[20px]">
                  Defensa jurídica ilimitada con abogados Línea Directa
                </p>
              </div>

              <div className="flex items-start gap-2">
                <div className="bg-[#ff6900] rounded-full w-[20px] h-[20px] flex items-center justify-center flex-shrink-0 mt-[2px]">
                  <svg
                    className="w-[12px] h-[12px]"
                    fill="none"
                    viewBox="0 0 12 12"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <p className="text-[#364153] text-[14px] leading-[20px]">
                  Reclamación de daños
                </p>
              </div>

              <div className="flex items-start gap-2">
                <div className="bg-[#ff6900] rounded-full w-[20px] h-[20px] flex items-center justify-center flex-shrink-0 mt-[2px]">
                  <svg
                    className="w-[12px] h-[12px]"
                    fill="none"
                    viewBox="0 0 12 12"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <p className="text-[#364153] text-[14px] leading-[20px]">
                  Gestión de multas y sanciones
                </p>
              </div>

              <div className="flex items-start gap-2">
                <div className="bg-[#ff6900] rounded-full w-[20px] h-[20px] flex items-center justify-center flex-shrink-0 mt-[2px]">
                  <svg
                    className="w-[12px] h-[12px]"
                    fill="none"
                    viewBox="0 0 12 12"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <p className="text-[#364153] text-[14px] leading-[20px]">
                  Asistencia jurídica
                </p>
              </div>
            </div>

            <button
              onClick={handleClick}
              className="w-full max-w-[456px] mx-auto block bg-[#ff6900] hover:bg-[#e05f00] text-white h-[44px] rounded-[6px] font-bold text-[18px] leading-[20px] transition-colors"
            >
              Contratar
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
